module.exports = __webpack_public_path__ + "img/gc_country_flag_bd.be744d41.svg";